import { Barcode, PackagePlus, ScanLine, Warehouse } from 'lucide-react';

import { defineArea } from '../../app/area';
import { PurchaseOrderDetailPage } from './pages/PurchaseOrderDetailPage';
import { PurchaseOrdersPage } from './pages/PurchaseOrdersPage';
import { PutawayPage } from './pages/PutawayPage';
import { ReceiptSessionPage } from './pages/ReceiptSessionPage';
import { ReceiptsPage } from './pages/ReceiptsPage';
import { TeachBarcodesPage } from './pages/TeachBarcodesPage';

/**
 * OWNER: the `receiving` module agent (M3 — docs/MODULES.md).
 * Owns: apps/web/src/areas/receiving/**  ·  apps/api/src/modules/receiving/**
 *       packages/shared/src/contracts/receiving.ts
 *       packages/shared/src/i18n/{sv,en,zh}/receiving.json  ·  e2e/receiving.md
 *
 * The purchase-order list sits in the ORDERS group and the receipt/put-away
 * flows in the WAREHOUSE group — that is how the floor thinks about them
 * (buying vs. handling), and it matches the brief's chrome.
 */
export default defineArea({
  id: 'receiving',
  nav: [
    {
      section: 'orders',
      to: '/orders/purchase',
      labelKey: 'common:nav.receiving.purchaseOrders',
      icon: PackagePlus,
      permissions: ['orders.inbound.list'],
      order: 20,
    },
    {
      section: 'warehouse',
      to: '/warehouse/receiving',
      labelKey: 'common:nav.receiving.receipts',
      icon: Warehouse,
      permissions: ['warehouse.goods.receive'],
      order: 5,
    },
    {
      section: 'warehouse',
      to: '/warehouse/putaway',
      labelKey: 'common:nav.receiving.putaway',
      icon: ScanLine,
      permissions: ['warehouse.goods.putaway'],
      order: 6,
    },
    {
      section: 'warehouse',
      to: '/warehouse/teach-barcodes',
      labelKey: 'common:nav.receiving.teachBarcodes',
      icon: Barcode,
      permissions: ['warehouse.barcodes.teach'],
      order: 90,
    },
  ],
  routes: [
    { path: 'orders/purchase', element: <PurchaseOrdersPage /> },
    { path: 'orders/purchase/:id', element: <PurchaseOrderDetailPage /> },
    { path: 'warehouse/receiving', element: <ReceiptsPage /> },
    { path: 'warehouse/receiving/:id', element: <ReceiptSessionPage /> },
    { path: 'warehouse/putaway', element: <PutawayPage /> },
    { path: 'warehouse/teach-barcodes', element: <TeachBarcodesPage /> },
  ],
});
